import BuildingType from '@/roc/building/BuildingType';
import Effects from '@/roc/effects/Effects';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';

const YurtOfTheKhan = {
  id: '40',
  name: "Yurt of the Khan",
  width: 4,
  height: 4,
  type: BuildingType.EVENT,
  era: 'stoneAge',
  icon: 'Yurt_Of_The_Khan',
  minLevel: 1,
  maxLevel: 60,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Yurt_of_the_Khan',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new PassiveAura(
      PassiveAuraType.GRANTS_CAPITAL_CITY_WORKER,
      EffectAmount.asPerLevel([
        0, 0, 0, 0, 0, 0,
        1, 1, 1, 1, 1, 1, 1,
        2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
        3, 3, 3, 3, 3, 3, 3,
        4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4,
        5, 5, 5, 5, 5,
      ]),
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asPerLevel([
        0, 0, 1.2, 1.2, 1.7, 1.7, 1.7, 2.1, 2.1, 2.1,
        2.1, 2.7, 2.7, 2.7, 2.7, 2.7, 3.1, 3.1, 3.1, 3.6,
        3.6, 3.6, 4.1, 4.1, 4.1, 4.1, 4.6, 4.6, 4.6, 5.2,
        5.2, 5.2, 5.2, 5.6, 5.6, 5.6, 6.3, 6.3, 6.3, 6.8,
        7, 7, 7, 7, 8, 8, 8, 8, 8, 8,
        9, 9, 9, 9, 9, 9, 10, 10, 10, 10
      ]).withOutput(ProductionOutputType.RESEARCH_POINTS),
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asPerEraAndLevel({
        stoneAge: [
          20,30,30,46,46,59,59,59,75,80,84,84,93,93,102,106,106,113,117,117,124,128,128,135,138,141,141,148,151,151,157,160,163,163,163,172,172,177,180,182,184,186,188,190,192,194,196,198,200,202,204,206,208,210,212,214,216,218,220,222
        ],
        bronzeAge: [
          23,35,35,54,54,69,69,69,87,93,99,99,109,109,119,124,124,133,137,137,145,150,150,158,161,165,165,173,176,176,184,187,191,191,191,201,201,208,211,213,215,217,219,221,223,225,227,229,231,233,235,237,239,241,243,245,247,249,251,253
        ],
        minoanEra: [
          33,50,50,75,75,96,96,96,122,130,138,138,153,153,166,173,173,186,192,192,204,209,209,221,226,231,231,242,247,247,257,262,267,267,267,281,281,291,295,299,301,304,307,309,312,315,317,320,323,326,328,331,334,336,339,342,344,347,350,353
        ],
        classicGreece: [
          53,80,80,121,121,154,154,154,197,210,222,222,245,245,267,278,278,298,308,308,327,336,336,354,363,372,372,389,397,397,413,421,429,429,429,452,452,467,474,480,484,489,494,498,503,508,512,517,522,527,531,536,541,545,550,555,559,564,569,574
        ],
        earlyRome: [
          64,98,98,148,148,189,189,189,240,256,271,271,300,300,327,340,340,365,377,377,400,411,411,433,444,454,454,475,485,485,505,515,524,524,524,552,552,571,580,586,592,598,604,610,616,622,628,634,640,646,652,658,664,670,676,682,688,694,700,706
        ],
        romanEmpire: [
          76,115,115,175,175,223,223,223,284,302,320,320,354,354,386,401,401,430,445,445,472,485,485,511,524,537,537,561,573,573,596,608,619,619,619,652,652,674,684,690,696,702,708,714,720,726,732,738,744,750,756,762,768,774,780,786,792,798,804,810
        ],
        byzantineEra: [
          76,115,115,175,175,223,223,223,284,302,320,320,354,354,386,401,401,430,445,445,472,485,485,511,524,537,537,561,573,573,596,608,619,619,619,652,652,674,684,690,696,702,708,714,720,726,732,738,744,750,756,762,768,774,780,786,792,798,804,810
        ],
        ageOfTheFranks: [
          76,115,115,175,175,223,223,223,284,302,320,320,354,354,386,401,401,430,445,445,472,485,485,511,524,537,537,561,573,573,596,608,619,619,619,652,652,674,684,690,696,702,708,714,720,726,732,738,744,750,756,762,768,774,780,786,792,798,804,810
        ],
        feudalAge: [
          76,115,115,175,175,223,223,223,284,302,320,320,354,354,386,401,401,430,445,445,472,485,485,511,524,537,537,561,573,573,596,608,619,619,619,652,652,674,684,690,696,702,708,714,720,726,732,738,744,750,756,762,768,774,780,786,792,798,804,810
        ],
        iberianEra: [
          76,115,115,175,175,223,223,223,284,302,320,320,354,354,386,401,401,430,445,445,472,485,485,511,524,537,537,561,573,573,596,608,619,619,619,652,652,674,684,690,696,702,708,714,720,726,732,738,744,750,756,762,768,774,780,786,792,798,804,810
        ],
        kingdomOfSicily: [
          76,115,115,175,175,223,223,223,284,302,320,320,354,354,386,401,401,430,445,445,472,485,485,511,524,537,537,561,573,573,596,608,619,619,619,652,652,674,684,690,696,702,708,714,720,726,732,738,744,750,756,762,768,774,780,786,792,798,804,810
        ],
        highMiddleAges: [
          76,115,115,175,175,223,223,223,284,302,320,320,354,354,386,401,401,430,445,445,472,485,485,511,524,537,537,561,573,573,596,608,619,619,619,652,652,674,684,690,696,702,708,714,720,726,732,738,744,750,756,762,768,774,780,786,792,798,804,810
        ],
        earlyGothicEra: [
          76,115,115,175,175,223,223,223,284,302,320,320,354,354,386,401,401,430,445,445,472,485,485,511,524,537,537,561,573,573,596,608,619,619,619,652,652,674,684,690,696,702,708,714,720,726,732,738,744,750,756,762,768,774,780,786,792,798,804,810
        ],
        lateGothicEra: [
          76,115,115,175,175,223,223,223,284,302,320,320,354,354,386,401,401,430,445,445,472,485,485,511,524,537,537,561,573,573,596,608,619,619,619,652,652,674,684,690,696,702,708,714,720,726,732,738,744,750,756,762,768,774,780,786,792,798,804,810
        ]
      }).withOutput(ProductionOutputType.CURRENT_ERA_TERTIARY_GOODS),
    ),
  ]),
};

export default YurtOfTheKhan;
